<template>
	<div class="b-badge" :class="classes">
		<slot>
			{{ text }}
		</slot>
	</div>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			default: "",
		},
		variant: {
			type: String,
			default: "default",
			validator: (value) =>
				["default", "success", "error", "info", "warning"].includes(value),
		},
	},
	computed: {
		classes() {
			return [`is-${this.variant}`];
		},
	},
};
</script>

<style lang="scss">
.b-badge {
	display: inline-flex;
	padding: 0 6px;
	gap: 5px;
	height: 24px;
	align-items: center;
	border-radius: 4px;
	text-align: center;
	white-space: nowrap;
	font-size: var(--font-size-2xs);
	font-weight: var(--font-weight-bold);

	&.is-default {
		color: var(--color-neutral-600);
		background-color: var(--color-neutral-50);
	}

	&.is-success {
		color: var(--color-success-400);
		background-color: var(--color-success-100);
	}

	&.is-error {
		color: var(--color-error-400);
		background-color: var(--color-error-100);
	}

	&.is-warning {
		color: var(--color-warning-400);
		background-color: var(--color-warning-100);
	}

	&.is-info {
		color: var(--color-info-400);
		background-color: var(--color-info-100);
	}
}
</style>
